import { render, staticRenderFns } from "./mgr-detail-review.vue?vue&type=template&id=0b128ee6&scoped=true"
import script from "./mgr-detail-review.vue?vue&type=script&lang=js"
export * from "./mgr-detail-review.vue?vue&type=script&lang=js"
import style0 from "./mgr-detail-review.vue?vue&type=style&index=0&id=0b128ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b128ee6",
  null
  
)

export default component.exports